import React from 'react';

import {
  Grid,
  Button,
  IconButton,
  RemoveCircleOutlineIcon,
} from '@gogame/components';
import { FormField, FormFieldArray } from '@gogame/form';

import {
  APPLICATION_SPEND,
  APPLICATION,
  SPEND,
} from 'scenes/MainBudgetPlanning/components/MainBudgetPlanningForm/constants';
import { applicationSpendSchema } from 'scenes/MainBudgetPlanning/components/MainBudgetPlanningForm/schemas';
import { loadApplications } from 'scenes/MainBudgetPlanning/sources/fields';

const ApplicationSpend = ({ name, addDisabled }) => {
  return (
    <FormFieldArray name={name}>
      {({ form, push, remove }) => {
        const value = form.values[name];

        if (!value) {
          return null;
        }

        return (
          <Grid container spacing={3}>
            {value.map((_, index) => (
              <React.Fragment key={index}>
                <Grid item xs={6}>
                  <FormField.Select
                    label={'Application'}
                    name={`${APPLICATION_SPEND}.[${index}].${APPLICATION}`}
                    source={loadApplications}
                    required={true}
                    padding={0}
                  />
                </Grid>
                <Grid item xs={5}>
                  <FormField.TextField
                    label={'Spend'}
                    name={`${APPLICATION_SPEND}.[${index}].${SPEND}`}
                    type={'number'}
                    required={true}
                    padding={0}
                  />
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    icon={<RemoveCircleOutlineIcon />}
                    onClick={() => remove(index)}
                    disabled={value.length < 2}
                    tooltip={'Remove'}
                  />
                </Grid>
              </React.Fragment>
            ))}
            <Grid item xs={12}>
              <Button
                add
                color={'primary'}
                onClick={() => {
                  push(applicationSpendSchema.default());
                }}
                disabled={addDisabled}
                variant={'outlined'}
              >
                Application
              </Button>
            </Grid>
          </Grid>
        );
      }}
    </FormFieldArray>
  );
};

export default ApplicationSpend;
